import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

// 创建axios实例
const service = axios.create({
  timeout: 10000 // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  config => {
    // 添加认证token
    const token = store.state.auth.token
    if (token) {
      // 根据要求，使用'Authorization'作为请求头参数名，并使用Bearer格式
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    
    // 检查是否是新的图片上传接口响应格式
    if (Object.prototype.hasOwnProperty.call(res, 'code') && 
        Object.prototype.hasOwnProperty.call(res, 'data') && 
        Object.prototype.hasOwnProperty.call(res, 'msg')) {
      
      // 新的图片上传接口格式：成功时 code: 200，失败时 code: 404
      if (res.code === 200) {
        return res // 成功，直接返回
      } else {
        // 失败，显示错误信息
        Message({
          message: res.msg || '请求失败',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(new Error(res.msg || '请求失败'))
      }
    }
    
    // 原有的后台管理接口格式：如果返回的状态码不是200，则显示错误信息
    if (res.code !== 200) {
      Message({
        message: res.message || '请求失败',
        type: 'error',
        duration: 5 * 1000
      })
      
      // 401: 未授权，跳转到登录页
      if (res.code === 401) {
        // 清除本地token
        store.commit('auth/CLEAR_AUTH')
        router.push('/login')
      }
      
      return Promise.reject(new Error(res.message || '请求失败'))
    }
    
    return res
  },
  error => {
    console.error('响应错误:', error)
    
    let message = '网络错误'
    
    if (error.response) {
      const { status, data } = error.response
      
      switch (status) {
        case 401:
          message = '登录已过期，请重新登录'
          // 清除本地token
          store.commit('auth/CLEAR_AUTH')
          router.push('/login')
          break
        case 403:
          message = '权限不足'
          break
        case 404:
          message = '请求的资源不存在'
          break
        case 500:
          message = '服务器内部错误'
          break
        default:
          message = data.message || `请求失败 (${status})`
      }
    }
    
    Message({
      message,
      type: 'error',
      duration: 5 * 1000
    })
    
    return Promise.reject(error)
  }
)

export default service